// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';  // for React 18+
import App from './App';
import { BrowserRouter } from 'react-router-dom';  // Import BrowserRouter
import theme from './theme';
import { ThemeProvider, CssBaseline } from '@mui/material';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>  {/* Ensure BrowserRouter wraps your app */}
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
